import React from "react";
import IconHolder from "../../../../Resources/svg/Icons/IconHolder";

interface SectionHeaderProps {
  title: string;
  style?: React.CSSProperties;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, style }) => {
  return (
    <div className="card-verify__header" style={style}>
      <IconHolder />
      <div className="card-verify__title">{title}</div>
    </div>
  );
};

export default SectionHeader;
